<template>
  <v-select v-on="$listeners" v-bind="defaultConfigs" />
</template>
<script>
const defaultProp = {
  outlined: true,
  dense: true,
  "background-color": "#F2F5FA"
};
export default {
  props: {
    filterable: { type: Boolean, default: false },
    searchable: { type: Boolean, default: false }
  },
  computed: {
    defaultConfigs() {
      return {
        ...this.$attrs,
        ...this.$props,
        ...defaultProp
      };
    }
  }
};
</script>
